const UPLOAD_ASSET_ORDER_DETAIL_ATTACHMENTS = 'UPLOAD_ASSET_ORDER_DETAIL_ATTACHMENTS';
const SET_ASSET_ORDER_DETAIL_ATTACHMENTS = 'SET_ASSET_ORDER_DETAIL_ATTACHMENTS';
const SET_ASSET_ORDER_DETAIL_LINKED_ATTACHMENTS = 'SET_ASSET_ORDER_DETAIL_LINKED_ATTACHMENTS';
const CREATE_BILL_OF_SALE = 'CREATE_BILL_OF_SALE';
const GET_BILL_OF_SALE_URL = 'GET_BILL_OF_SALE_URL';
const SET_BILL_OF_SALE_URL = 'SET_BILL_OF_SALE_URL';
const SET_IS_BILL_OF_SALE_CREATED = 'SET_IS_BILL_OF_SALE_CREATED';

export {
    UPLOAD_ASSET_ORDER_DETAIL_ATTACHMENTS,
    SET_ASSET_ORDER_DETAIL_ATTACHMENTS,
    SET_ASSET_ORDER_DETAIL_LINKED_ATTACHMENTS,
    CREATE_BILL_OF_SALE,
    GET_BILL_OF_SALE_URL,
    SET_BILL_OF_SALE_URL,
    SET_IS_BILL_OF_SALE_CREATED,
};
